import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import SafeUrlAssembler from 'safe-url-assembler';
import { Observable } from 'rxjs';
import { HttpClientService } from '../../../core/services/http/http-client.service';
import { HttpClient, HttpRequest, HttpHeaders } from '@angular/common/http';
import { IRewardShip } from '../../models/rewardShip.interface';
import { ApiEndpointService } from '../../../core/services/api-endpoint.service';
import { IInvoiceSearch } from '../models/invoice-search.interface';
import { IDigitalWalletRewardShip } from '../models/digital-wallet-rewards.interface';
import { IRedemptionResponse } from '../models/redemption-response.interface';
@Injectable()
export class DigitalWalletService {

  constructor(private httpClient: HttpClient,
              private httpClientService: HttpClientService,
              private apiEndpointService: ApiEndpointService) {
  }


  /**
   * Gets Rewards history.
   *
   * @returns {Observable}
   */
  public getRewardsHistory(pageIndex: number, pageSize: number): Observable<IRewardShip[]> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('getRewardsHistory'))
      .query({
        page: pageIndex,
        per_page: pageSize,
      })
      .toString();
    return this.httpClientService.get<IRewardShip[]>(endpoint);
  }

  public getInvoice(invoiceId: string): Observable<any> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('getInvoice'))
      .param('invoiceId', invoiceId)
      .toString();
    return this.httpClientService.get<any>(endpoint);
  }

  /**
   * Returns Invoice history.
   *
   * @returns {Observable}
   */
  public getInvoiceHistory(invDetails : IInvoiceSearch): Observable<IDigitalWalletRewardShip[]> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('getDWRewardsHistory'))
      .toString();
    return this.httpClientService.post<any>(endpoint, invDetails);
  }

  /**
   * Returns Invoice history.
   *
   * @returns {Observable}
   */
  public getAllInvoiceHistory(invDetails : IInvoiceSearch): Observable<IDigitalWalletRewardShip[]> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('getDWRewardsHistory'))
      .toString();
    return this.httpClientService.post<any>(endpoint, invDetails);
  }

   /**
   * Returns Open Invoices
   *
   * @returns {Observable}
   */
   public getOpenInvoices(): Observable<IDigitalWalletRewardShip[]> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('getDWOpenInvoices'))
      .toString();
    return this.httpClientService.get<any>(endpoint);
  }

  /**
   * Gets Auto Redeem flag.
   *
   * @returns {Observable}
   */
  public getAutoRedeemFlag(customerId: String): Observable<any> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getAutoRedeemFlag')).query({CustomerID: customerId}).toString();
    return this.httpClientService.get<any>(endpoint);
  }

  /**
   * Updates Auto Redeem flag.
   *
   * @returns {Observable}
   */
  public postAutoRedeemFlag(customerId: String, isAutoRedeem: Boolean): Observable<any> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('postAutoRedeemFlag')).query({CustomerID: customerId, isAutoRedeem: isAutoRedeem}).toString();
    // return this.httpClientService.post<any>(endpoint, null);
    return this.httpClient.post(endpoint, null, {responseType: 'text'});
  }

  /**
   * Fetch balance from DW API.
   *
   * @returns {Observable}
   */
  public getDWBalance(customerId: string): Observable<any> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getDWBalance')).param('customerId', customerId).toString();
    return this.httpClientService.get<any>(endpoint);
  }

  /**
   * Redeem the rewards.
   *
   * @returns {Observable}
   */
  public redeemRewards(): Observable<any> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('redeemRewards')).toString();
    return this.httpClientService.put<any>(endpoint, '');
  }

  /**
   * Gets Rewards history header.
   *
   * @returns {Observable}
   */
  public getRewardsHistoryHeader(): Observable<any> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getRewardsHistoryHeader')).toString();
    return this.httpClientService.get<any>(endpoint);
  }

  /**
   * Checks DW Customer.
   *
   * @returns {Observable}
   */
  public getCheckDWCustomer(): Observable<boolean> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getCheckDWCustomer')).toString();
    return this.httpClientService.get<any>(endpoint)
        .pipe(
            map(res => typeof res === 'boolean' ? res : res.exists),
        );
  }

  /**
   * Updates number of points to redeem to specific invoice id for customer.
   *
   * @returns {Observable}
   */
  public postRedeem(data: any): Observable<IRedemptionResponse> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('postRedeem'))
      .toString();
    return this.httpClientService.post<IRedemptionResponse>(endpoint, data);
  }

  /**
   * Updates T&C flag.
   *
   * @returns {Observable}
   */
  public postTCFlag(): Observable<IDigitalWalletRewardShip[]> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('postTCFlag'))
      .toString();
    return this.httpClientService.post<any>(endpoint, true);
  }

  /**
   * Gets DW KPI metrics.
   *
   * @returns {Observable}
   */
  public getKPIMetrics(): Observable<any> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getKPIMetrics')).toString();
    return this.httpClientService.get<any>(endpoint);
  }

  public getTermsAndCondAccepted(): Observable<any> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getTermsAndCondAccepted')).toString();
    return this.httpClientService.get<any>(endpoint);
  }

  /**
   * Updates number of points to redeem to specific invoice id for customer.
   *
   * @returns {Observable}
   */
  public postAdvancedFilter(data: any): Observable<IRedemptionResponse> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('postAdvancedFilter'))
      .toString();
    return this.httpClientService.post<IRedemptionResponse>(endpoint, data);
  }
}
